export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	TeamApiProvider: Symbol("TeamApiProvider"),
	TradeApiProvider: Symbol("TradeApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	CountriesStore: Symbol("CountriesStore"),
	StatesStore: Symbol("StatesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	LocalizationController: Symbol("LocalizationController"),
	MenuStore: Symbol("MenuStore"),
	TeamStore: Symbol("TeamStore"),
	StaticContentStore: Symbol("StaticContentStore"),
	ModalsStore: Symbol("ModalsStore"),
	AuthController: Symbol("AuthController"),
	LoginController: Symbol("LoginController"),
	RegistrationController: Symbol("RegistrationController"),
	MyAccountController: Symbol("MyAccountController"),
	SecretGateController: Symbol("SecretGateController"),
	HelpController: Symbol("HelpController"),
	PrizeController: Symbol("PrizeController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	PlayedGamesController: Symbol("PlayedGamesController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	CookieBannerController: Symbol("CookieBannerController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	HeaderController: Symbol("HeaderController"),
	MenuController: Symbol("MenuController"),
	ModalsController: Symbol("ModalsController"),
	GameController: Symbol("GameController"),
	TeamSelectorController: Symbol("TeamSelectorController"),
	PlayerSlotController: Symbol("PlayerSlotController"),
	RoundNavigatorController: Symbol("RoundNavigatorController"),
	SaveBarController: Symbol("SaveBarController"),
	PlayerPoolStore: Symbol("PlayerPoolStore"),
	PoolController: Symbol("PoolController"),
	UserBarController: Symbol("UserBarController"),
	PoolModalController: Symbol("PoolModalController"),
	CreateLeagueController: Symbol("CreateLeagueController"),
	LeaguesStore: Symbol("LeaguesStore"),
	LeagueInviteFormController: Symbol("LeagueInviteFormController"),
	LeaguesApiProvider: Symbol("LeaguesApiProvider"),
	MyLeaguesController: Symbol("MyLeaguesController"),
	JoinCreateLeagueController: Symbol("JoinCreateLeagueController"),
	LeagueCardController: Symbol("LeagueCardController"),
	JoinLeagueCardController: Symbol("JoinLeagueCardController"),
	InviteCreateLeagueCardController: Symbol("InviteCreateLeagueCardController"),
	LeaderboardController: Symbol("LeaderboardController"),
	RankingsApiProvider: Symbol("RankingsApiProvider"),
	RankingsStore: Symbol("RankingsStore"),
	LeagueController: Symbol("LeagueController"),
	LeagueAboutController: Symbol("LeagueAboutController"),
	LeagueInviteController: Symbol("LeagueInviteController"),
	LeagueSettingsController: Symbol("LeagueSettingsController"),
	LeagueStandingsController: Symbol("LeagueStandingsController"),
	JoinLeaguesController: Symbol("JoinLeaguesController"),
	TiebreakerModalController: Symbol("TiebreakerModalController"),
	ConfirmModalController: Symbol("ConfirmModalController"),
	KeyIndicatorController: Symbol("KeyIndicatorController"),
	TeamSavedModalController: Symbol("TeamSavedModalController"),
	TutorialModalController: Symbol("TutorialModalController"),
	LandingController: Symbol("LandingController"),
	InfoTradeModalController: Symbol("InfoTradeModalController"),
	PlayerPoolSlotController: Symbol("PlayerPoolSlotController"),
	HowToScoreModalController: Symbol("HowToScoreModalController"),
	SaveTeamModalController: Symbol("SaveTeamModalController"),
	PromptModalController: Symbol("PromptModalController"),
	RankingsTableController: Symbol("RankingsTableController"),
	TradesConfirmModalController: Symbol("TradesConfirmModalController"),
	UserTeamController: Symbol("UserTeamController"),
	UserTeamSelectorController: Symbol("UserTeamSelectorController"),
	FooterController: Symbol("FooterController"),
	UserTeamRoundNavigatorController: Symbol("UserTeamRoundNavigatorController"),
	ModalPlayerProfileController: Symbol("ModalPlayerProfileController"),
	PlayerProfileOverviewController: Symbol("PlayerProfileOverviewController"),
	PlayerProfileSessionsController: Symbol("PlayerProfileSessionsController"),
	PlayerProfileInfoController: Symbol("PlayerProfileInfoController"),
	InfoSessionModalController: Symbol("InfoSessionModalController"),
	ChangeCaptainModalController: Symbol("ChangeCaptainModalController"),
};
